module.exports = __webpack_public_path__ + "img/modal-tip.94ad5333.png";